// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YbrS","content":"styles_content__3gzbq","tableWrap":"styles_tableWrap__1kDZA"};